if (!customElements.get('wate-localization')) {
  customElements.define(
    'wate-localization',
    class WateLocalization extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.wate-loc__button');
        this.panel = this.querySelector('.wate-loc__panel');
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="locale_code"], input[name="country_code"]');

        if (!this.button || !this.panel || !this.form || !this.input) return;

        this.onDocumentClick = this.onDocumentClick.bind(this);

        this.button.addEventListener('click', this.toggle.bind(this));
        this.addEventListener('keydown', this.onKeyDown.bind(this));

        this.querySelectorAll('[data-value]').forEach((item) => {
          item.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.value = item.dataset.value;
            this.form.submit();
          });
        });
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
      }

      get isOpen() {
        return !this.panel.hasAttribute('hidden');
      }

      toggle() {
        this.isOpen ? this.close() : this.open();
      }

      open() {
        document.querySelectorAll('wate-localization').forEach((el) => {
          if (el !== this && typeof el.close === 'function') el.close();
        });

        this.panel.removeAttribute('hidden');
        this.button.setAttribute('aria-expanded', 'true');
        document.addEventListener('click', this.onDocumentClick);
      }

      close() {
        if (!this.isOpen) return;
        this.panel.setAttribute('hidden', '');
        this.button.setAttribute('aria-expanded', 'false');
        document.removeEventListener('click', this.onDocumentClick);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.close();
      }

      onKeyDown(event) {
        if (event.key !== 'Escape' || !this.isOpen) return;
        this.close();
        this.button.focus();
      }
    }
  );
}
